<p-tabs [className]="'simple-selector hide-active-tab'" [(value)]="selectedTab">
    <p-tablist [className]="'hide-active-tab backgroundWhite align-items-center'">
        <p-tab [value]="'Dag'">Dag</p-tab>
        <p-tab [value]="'Week'">Week</p-tab>
        <p-tab [value]="'WeekDetails'">Week Details</p-tab>
        <p-tab [value]="'Maand'">Maand</p-tab>
        <p-tab [value]="'Jaar'">Jaar</p-tab>
    </p-tablist>
    <p-tabpanels>
        <p-tabpanel [value]="'Dag'">
            <div class="row">
                <div class="col-4">
                    <p>EAN</p>
                    <p-select [fluid]="true" [options]="eans" [(ngModel)]="selectedEAN" (ngModelChange)="generateDataForDate(selectedDate)">
                        <ng-template let-ean pTemplate="item">
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="ean.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ ean.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{ean.ean}}</span>
                            </div>
                        </ng-template>
                        <ng-template #selectedItem>
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="selectedEAN.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ selectedEAN.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{selectedEAN.ean}}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class=" col-8">
                    <p>&nbsp;</p>
                    <div class="flex justify-content-end">
                        <p-datepicker [firstDayOfWeek]="1" useUtc [locale]="be" [maxDate]="today" #daypicker dateFormat="d-mm-yy" [(ngModel)]="selectedDate" (ngModelChange)="generateDataForDate(selectedDate);"></p-datepicker><span>&nbsp;</span>
                    </div>
                </div>
            </div>
            <graph-component [data]="chartDataPerDate" [options]="chartOptions"></graph-component>
        </p-tabpanel>
        <p-tabpanel [value]="'Week'">
            <div class="row">
                <div class="col-4">
                    <p>EAN</p>
                    <p-select [fluid]="true" [options]="eans" [(ngModel)]="selectedEAN" (ngModelChange)="generateDataForWeek(selectedWeek)">
                        <ng-template let-ean pTemplate="item">
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="ean.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ ean.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{ean.ean}}</span>
                            </div>
                        </ng-template>
                        <ng-template #selectedItem>
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="selectedEAN.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ selectedEAN.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{selectedEAN.ean}}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class=" col-8">
                    <p>&nbsp;</p>
                    <div class="flex justify-content-end">
                        <p-datepicker [firstDayOfWeek]="1" [locale]="be" [showWeek]="true" [maxDate]="today" #weekpicker [selectionMode]="'range'" dateFormat="d-mm-yy" [(ngModel)]="selectedWeek" (ngModelChange)="generateDataForWeek(selectedWeek);"></p-datepicker><span>&nbsp;</span>
                    </div>
                </div>
            </div>
            <graph-component [data]="chartDataPerWeek" [options]="chartOptions"></graph-component>
        </p-tabpanel>
        <p-tabpanel [value]="'WeekDetails'">
            <div class="row">
                <div class="col-4">
                    <p>EAN</p>
                    <p-select [fluid]="true" [options]="eans" [(ngModel)]="selectedEAN" (ngModelChange)="generateDataForWeekDetails(selectedWeekDetails)">
                        <ng-template let-ean pTemplate="item">
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="ean.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ ean.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{ean.ean}}</span>
                            </div>
                        </ng-template>
                        <ng-template #selectedItem>
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="selectedEAN.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ selectedEAN.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{selectedEAN.ean}}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class=" col-8">
                    <p>&nbsp;</p>
                    <div class="flex justify-content-end">
                        <p-datepicker [firstDayOfWeek]="1" [locale]="be" [showWeek]="true" [maxDate]="today" #weekdetailspicker [selectionMode]="'range'" dateFormat="d-mm-yy" [(ngModel)]="selectedWeekDetails" (ngModelChange)="generateDataForWeekDetails(selectedWeekDetails);"></p-datepicker><span>&nbsp;</span>
                    </div>
                </div>
            </div>
            <graph-component [data]="chartDataPerWeekDetails" [options]="chartOptions"></graph-component>
        </p-tabpanel>
        <p-tabpanel [value]="'Maand'">
            <div class="row">
                <div class="col-4">
                    <p>EAN</p>
                    <p-select [fluid]="true" [options]="eans" [(ngModel)]="selectedEAN" (ngModelChange)="generateDataForMonth(selectedMonth)">
                        <ng-template let-ean pTemplate="item">
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="ean.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ ean.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{ean.ean}}</span>
                            </div>
                        </ng-template>
                        <ng-template #selectedItem>
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="selectedEAN.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ selectedEAN.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{selectedEAN.ean}}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class=" col-8">
                    <p>&nbsp;</p>
                    <div class="flex justify-content-end">
                        <p-datepicker [firstDayOfWeek]="1" [locale]="be" [maxDate]="today" #monthpicker dateFormat="MM yy" [view]="'month'" [selectionMode]="'range'" [(ngModel)]="selectedMonth" (ngModelChange)="generateDataForMonth(selectedMonth);"></p-datepicker><span>&nbsp;</span>
                    </div>
                </div>
            </div>
            <graph-component [data]="chartDataPerMonth" [options]="chartOptions"></graph-component>
        </p-tabpanel>
        <p-tabpanel [value]="'Jaar'">
            <div class="row">
                <div class="col-4">
                    <p>EAN</p>
                    <p-select [fluid]="true" [options]="eans" [(ngModel)]="selectedEAN" (ngModelChange)="generateDataForYear(selectedYear)">
                        <ng-template let-ean pTemplate="item">
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="ean.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ ean.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{ean.ean}}</span>
                            </div>
                        </ng-template>
                        <ng-template #selectedItem>
                            <div class="flex">
                                <span class="align-content-center" [style]="{ 'font-size': selectedEAN.type == NutsType.Elektriciteit ? '22px' : '24px' }" [class]="selectedEAN.type == NutsType.Elektriciteit ? 'pi pi-bolt ebemGreen' : 'material-icons ebemBlue'">{{ selectedEAN.type == NutsType.Gas ? 'local_fire_department' : ''}}</span><span>&nbsp;</span><span class="align-content-center">{{selectedEAN.ean}}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class=" col-8">
                    <p>&nbsp;</p>
                    <div class="flex justify-content-end">
                        <p-datepicker [firstDayOfWeek]="1" [locale]="be" [maxDate]="today" [view]="'year'" #yearpicker dateFormat="yy" [selectionMode]="'range'" [(ngModel)]="selectedYear" (ngModelChange)="generateDataForYear(selectedYear);"></p-datepicker><span>&nbsp;</span>
                    </div>
                </div>
            </div>
            <graph-component [data]="chartDataPerYear" [options]="chartOptions"></graph-component>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>
